import React from 'react';

export default function LockOpenIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-lock-open"><g><path className="secondary" d="M12 19v3H5a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h7v3a2 2 0 0 0-1 3.73V18a1 1 0 0 0 1 1z"/><path className="primary" d="M12 19a1 1 0 0 0 1-1v-1.27A2 2 0 0 0 12 13v-3h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7v-3zm5-12a1 1 0 0 1-2 0 3 3 0 0 0-6 0v3H7V7a5 5 0 1 1 10 0z"/></g></svg>
    </Tag>
  )
};
